<template>
  <div
    class="button is-primary is-light font-semibold"
    @click="is_show_dialog = true"
  >
    <div class="icon">
      <AppIcon name="solid-stars" />
    </div>
    <span
      v-if="$slots.default"
      class="font-semibold"
    >
      <slot />
    </span>
    <span
      v-else
      class="font-semibold"
    >
      {{ $t(`upsell.${feature}.cta`) }}
    </span>
    <PrimeDialog
      v-model:visible="is_show_dialog"
      modal
    >
      <template #header>
        <div class="inline-flex items-center justify-center gap-2">
          <AppIcon
            name="solid-stars"
            size="2x"
          />
          <div class="title is-3 ml-2">
            {{ $t(`upsell.${feature}.title`) }}
          </div>
        </div>
      </template>
      <LiteYouTubeEmbed
        v-if="$te(`upsell.${feature}.youtube_id`)"
        :id="$t(`upsell.${feature}.youtube_id`)"
        ref="youtube"
        title="video"
      />
      <div class="px-2 py-1">
        <div
          class="mt-3"
          v-html="$t(`upsell.${feature}.description`)"
        />
      </div>
      <template #footer>
        <ButtonPrimary @onClick="openIntercom">
          {{ $t('upsell.contact_us') }}
        </ButtonPrimary>
      </template>
    </PrimeDialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LiteYouTubeEmbed from 'vue-lite-youtube-embed';
import 'vue-lite-youtube-embed/style.css';
import { mapGetters } from '@/store/lib/vue3helpers.js';
import useSupportChat from '@/composables/useSupportChat';

const props = defineProps({
  feature: { type: String, required: true },
});

const emit = defineEmits(['usell-close']);

const { t } = useI18n();
const { current_profile } = mapGetters(['current_profile']);
const { openSupportChat } = useSupportChat();

const is_show_dialog = ref(false);

function openIntercom() {
  const message = t(`upsell.${props.feature}.intercom`, { name: current_profile.value.attributes.name });
  openSupportChat(message);
  is_show_dialog.value = false;
  emit('usellClose');
}
</script>
